<template>
  <div class="stock-wrap">
    <div class="search-hd">
      <div class="item-tip">
        <i class="icon icon-tishi"></i>
        <span>{{ $t('dms_stock_wait.xzfhdhzryynjzdsbshrk') }}</span>
      </div>
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button v-if="funcView.be_stock_receipt" :disabled="!selectRow || !selectRow.shipmentNum" type="primary" @click="inStockDialog">
            <i class="icon icon-instock"></i>
            {{ funcView.be_stock_receipt }}
          </el-button>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item style="float: right; margin-right: 0" v-if="funcView.be_stock_export">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable('stockExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_stock_wait.jshmodemSNfhdh')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_stock_wait.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_wait.fa_huo_fang')">
          <el-input v-model="formSearch.orgName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_wait.fa_huo_ren')">
          <el-input v-model="formSearch.operator"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_wait.fa_huo_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="dataTimes"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        key="1"
        type="radio"
        v-model="selectRow"
        tableCode="waitStockManage"
        :data="tableList"
        height="100%"
        @filter="filterChange"
        @sort="sortChange"
        @column="setColumn"
        :slots="['bodyNum']"
      >
        <template slot="bodyNum" slot-scope="scope">
          <div class="cell-link" @click="jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.path })">{{ scope.row.bodyNum }}</div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 入库 -->
    <instock-device-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getTableList()"></instock-device-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import instockDeviceDialog from './instock_device_dialog.vue';

export default {
  components: {
    instockDeviceDialog,
  },
  data() {
    return {
      selectRow: {},
      dataTimes: [],
      formSearch: {
        stockInState: '1',
        productCode: '',
        // siteName: '',
        // orgName: '',
        shipperOrgName: '',
        operator: '',
        // timezone: '',
        startTime: '',
        endTime: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: null,
      dialogVisible2: false,
      dialogModel2: {},
    };
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.startTime = this.dataTimes ? this.dataTimes[0] : '';
      this.formSearch.endTime = this.dataTimes ? this.dataTimes[1] : '';
      this.$getJSON(apis.stockDevicePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清空
    clearFilter: function () {
      this.dataTimes = [];
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    // 入库
    inStockDialog: function () {
      this.dialogModel2 = { title: this.$t('dms_stock_wait.shou_huo_ru_ku'), row: this.selectRow };
      this.dialogVisible2 = true;
    },
  },
};
</script>
